var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 17.2",
    style: {
      enableBackground: "new 0 0 20 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE0E54;}\n\t.st1{fill:#00C213;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.7,9.9l1.4,0.3l1-1.6L1.1,8.2C0.6,8.1,0.2,8.3,0,8.8S0.2,9.8,0.7,9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,10.2l-4.5,4l-5.2-4.1C8.7,10.1,8.6,10,8.4,10L7.7,9.8l-1,1.6l1.1,0.3l5.7,4.4c0.3,0.3,0.8,0.3,1.2,0 l5-4.5c0.4-0.3,0.4-0.9,0.1-1.3c0,0,0,0,0,0C19.4,9.9,18.9,9.9,18.5,10.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,5.8l4.9,3.1c0.4,0.3,1,0.2,1.2-0.2l5-7.2c0.3-0.4,0.2-1-0.2-1.3c0,0,0,0,0,0c-0.4-0.3-1-0.2-1.3,0.2 l-4.5,6.5L8.9,3.8C8.7,3.6,8.4,3.6,8.2,3.6C8,3.7,7.8,3.8,7.6,4L0.1,15.8c-0.3,0.4-0.1,1,0.3,1.2c0.1,0.1,0.3,0.1,0.5,0.1 c0.3,0,0.6-0.2,0.8-0.4C1.7,16.8,8.7,5.8,8.7,5.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeViewIcon);
export default __webpack_public_path__ + "static/media/change_view_icon.4079c5eb46ed9c6c890a0edd58bd4da3.svg";
export { ForwardRef as ReactComponent };